const RESERVED_IMPORTED_SHAPE_KEYS = new Set([
  'id',
  'type',
  'name',
  'description',
  'colour',
  'color',
  'opacity',
  'borderColour',
  'borderColor',
  'borderWidth',
  'isLocked',
  'coordinates',
  'arrowStyle',
  'originPointId',
  'destPointId',
  'time',
  'request_time',
  'requestType',
  'request_type',
  'userId',
  'user_id',
  'rideId',
  'ride_id',
  'numPassengers',
  'standard_seat',
  'wheelchair',
  'from_address',
  'to_address',
]);

const RENAMED_IMPORTED_SHAPE_KEYS: Record<string, string> = {
  id: 'imported_source_id',
  type: 'imported_source_type',
};

export function sanitizeImportedShapeMetadata(row: Record<string, unknown>): Record<string, unknown> {
  const metadata: Record<string, unknown> = {};

  Object.entries(row).forEach(([key, value]) => {
    const renamedKey = RENAMED_IMPORTED_SHAPE_KEYS[key];
    if (renamedKey) {
      metadata[renamedKey] = value;
      return;
    }

    if (RESERVED_IMPORTED_SHAPE_KEYS.has(key)) {
      return;
    }

    metadata[key] = value;
  });

  return metadata;
}
